import { Action } from 'redux';
import { spawn, actionChannel, take, call } from 'redux-saga/effects';

/**
 * Places all actions that matches patterns from the map into a queue to run these actions sequentially.
 */
export function* takeOneByOneMany(
    workerMap: { [pattern: string]: (action: Action) => any }
) {
    yield spawn(takeOneByOneWatch);

    function* takeOneByOneWatch() {
        const channel = yield actionChannel('*');

        while (true) {
            const payload = yield take(channel);
            const worker = workerMap[payload.type];

            if (worker !== undefined) {
                yield call(worker, payload);
            }
        }
    }
}